import React, { useEffect, useState } from "react";
import { Alert, Button, Snackbar } from "@mui/material";
import InstallMobileIcon from "@mui/icons-material/InstallMobile";
import { canInstallPWA, promptInstall } from "../../pwa";

export default function InstallPrompt() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onInstallable = () => {
      if (sessionStorage.getItem("pwa-install-dismissed") !== "1") setOpen(true);
    };
    window.addEventListener("pwa-installable", onInstallable);
    if (canInstallPWA()) setOpen(true);
    return () => window.removeEventListener("pwa-installable", onInstallable);
  }, []);

  const install = async () => {
    await promptInstall();
    setOpen(false);
  };
  const dismiss = () => {
    sessionStorage.setItem("pwa-install-dismissed", "1");
    setOpen(false);
  };

  return (
    <Snackbar open={open} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
      <Alert
        severity="info"
        icon={<InstallMobileIcon />}
        action={<><Button color="inherit" size="small" onClick={install}>Install</Button><Button color="inherit" size="small" onClick={dismiss}>Later</Button></>}
      >
        Install InfyU HRMS as an app for a better experience
      </Alert>
    </Snackbar>
  );
}
